<template>
    <v-layout v-if="shows" column style="gap:8px">
        <v-card flat outlined rounded="xl">
            <v-btn v-bind="{ disabled: disabled_increase }" small icon color="primary" class="white" @click="increaseZoom">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-card>
        <v-card flat outlined rounded="xl">
            <v-btn v-bind="{ disabled: disabled_decrease }" small icon color="primary" class="white" @click="decreaseZoom">
                <v-icon>mdi-minus</v-icon>
            </v-btn>
        </v-card>
    </v-layout>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
    props: {
        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
        hideZoom: { type: Boolean, default: false },
    },
    computed: {
        ...mapGetters("employment/form/page", ["disabled_decrease", "disabled_increase"]),
        shows() {
            if (this.hideZoom) return false;

            switch (this.mode) {
                case "form":
                case "sign": {
                    return false;
                }

                default: {
                    return true;
                }
            }
        },
    },
    methods: {
        ...mapMutations("employment/form/page", ["decreaseZoom", "increaseZoom"]),
    },
};
</script>

<style></style>
